import { QrCode, Camera, PenLine, Receipt } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAddSheet } from "@/context/AddSheetContext";
import { useI18n } from "@/context/I18nContext";

const ACTIONS = [
  { icon: QrCode, mode: "qr", key: "qr", labelKey: "qr" },
  { icon: Camera, mode: "photo", key: "photo", labelKey: "photo" },
  { icon: PenLine, mode: "manual", key: "manual", labelKey: "manual" },
  { icon: Receipt, mode: "cheque", key: "cheque", labelKey: "cheque" },
];

export function NeuQuickActions() {
  const nav = useNavigate();
  const { t } = useI18n();
  const { openAdd } = useAddSheet();
  const handle = (a) => (a.mode ? openAdd(a.mode) : nav(a.to));
  return (
    <div className="neu p-4">
      <div className="grid grid-cols-4 gap-3">
        {ACTIONS.map((a) => (
          <button
            key={a.key}
            data-testid={`neu-action-${a.key}`}
            onClick={() => handle(a)}
            className="flex flex-col items-center gap-1.5 py-2 rounded-2xl neu-btn hover:-translate-y-0.5 active:scale-95 transition-all"
          >
            <div className="w-11 h-11 rounded-full neu-fill-blue grid place-items-center shadow-md shadow-blue-900/20">
              <a.icon className="w-5 h-5 text-white" strokeWidth={2.2} />
            </div>
            <span className="text-[10px] font-semibold neu-accent-blue">{t(a.labelKey)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
